var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWrenchNice(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 511.902 511.902",
    style: {
      enableBackground: "new 0 0 511.902 511.902"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A3AAAF"
    },
    d: "M185.379,88.276h79.448C260.414,66.207,210.979,0,185.379,0V88.276z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E0E0E0"
    },
    d: "M444.028,445.793L301.903,218.924c-23.834-38.841-37.076-84.745-37.076-130.648H114.759V0 c-25.6,12.359-52.966,40.607-52.966,79.448c0,37.959,15.007,58.262,39.724,72.386l0,0c52.966,29.131,97.986,70.621,130.648,121.821 L368.11,489.931c12.359,21.186,38.841,28.248,60.028,15.89C449.324,493.462,456.386,466.979,444.028,445.793"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A3AAAF"
    },
    d: "M176.552,158.897h52.966v-35.31h-52.966V158.897z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A3AAAF"
    },
    d: "M379.586,432.552h-42.372c-1.766,0-3.531,0.883-4.414,1.766l9.71,15.89h37.076 c5.297,0,8.828-3.531,8.828-8.828S384.883,432.552,379.586,432.552"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#A3AAAF"
    },
    d: "M353.103,397.241h-37.959c-1.766,0-3.531,0.883-4.414,1.766l10.593,15.89h31.779 c5.297,0,8.828-3.531,8.828-8.828S358.4,397.241,353.103,397.241"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWrenchNice);
export default __webpack_public_path__ + "static/media/wrench-nice.26d8eddc60da6e07ae40c41f56834310.svg";
export { ForwardRef as ReactComponent };